import { faLongArrowDown, faLongArrowUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import {
    BZ2_SORT_COMPLAINTS_SHORT,
    BZ2_SORT_COMPLAINT_TIME_SHORT,
    BZ2_SORT_CREATION,
    BZ2_SORT_PRICE,
    BZ2_SORT_PRICE_DESC,
    BZ2_SORT_SCORE,
    BZ2_SORT_SCORE_NEW,
    BZ2_SORT_UPDATED,
    BZ2_SORT_WATCHDOG,
    BZ2_SORT_WISHLIST,
} from "@/mk/autogenerated/translation";
import {
    SORTING_VALUES as ENUM_SORTING_VALUES,
    WISHLIST_SORTING_VALUES as ENUM_WISHLIST_SORTING_VALUES,
} from "@/mk/bazaar/common/enums";

import styles from "./SortLabel.mscss";

interface OwnProps {
    className?: string;
    label: React.ReactNode;
    direction: "asc" | "desc";
}

type Props = OwnProps;

const SortLabel: React.FunctionComponent<Props> = ({ className, label, direction }) => (
    <span className={cx(styles.SortLabel, className)}>
        {label}
        &nbsp;
        <FontAwesomeIcon icon={direction === "asc" ? faLongArrowUp : faLongArrowDown} />
    </span>
);

SortLabel.displayName = "SortLabel";

export default React.memo<Props>(SortLabel);

export const SORTING_VALUES: {
    [T in keyof typeof ENUM_SORTING_VALUES]: React.ReactNode;
} = {
    update: BZ2_SORT_UPDATED,
    creation: BZ2_SORT_CREATION,
    price_desc: BZ2_SORT_PRICE_DESC,
    price: BZ2_SORT_PRICE,
    score_new: BZ2_SORT_SCORE_NEW,
    complaints: (
        <SortLabel
            className={styles["SortLabel--moderator"]}
            label={BZ2_SORT_COMPLAINTS_SHORT}
            direction="desc"
        />
    ),
    complaints_asc: (
        <SortLabel
            className={styles["SortLabel--moderator"]}
            label={BZ2_SORT_COMPLAINTS_SHORT}
            direction="asc"
        />
    ),
    complaint_time: (
        <SortLabel
            className={styles["SortLabel--moderator"]}
            label={BZ2_SORT_COMPLAINT_TIME_SHORT}
            direction="desc"
        />
    ),
    complaint_time_asc: (
        <SortLabel
            className={styles["SortLabel--moderator"]}
            label={BZ2_SORT_COMPLAINT_TIME_SHORT}
            direction="asc"
        />
    ),
    watchdog: BZ2_SORT_WATCHDOG,
    score: BZ2_SORT_SCORE,
    // score: <span>{BZ2_SORT_SCORE} <sup className={styles.SortLabel__newFeature}>{NEW_FEATURE_TAG}</sup></span>,
};

export const WISHLIST_SORTING_VALUES: {
    [T in keyof typeof ENUM_WISHLIST_SORTING_VALUES]: React.ReactNode;
} = {
    wishlist: <SortLabel label={BZ2_SORT_WISHLIST} direction="desc" />,
    wishlist_asc: <SortLabel label={BZ2_SORT_WISHLIST} direction="asc" />,
};
